import { render } from "./Admin-Patients.vue?vue&type=template&id=199d92d6"
import script from "./Admin-Patients.vue?vue&type=script&lang=js"
export * from "./Admin-Patients.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__